import { Component } from '@angular/core';
import { App, NavController } from 'ionic-angular';

@Component({
  selector: 'public',
  templateUrl: 'public.html'
})
export class PublicPage {

  constructor(public app: App, public nav: NavController) { }

  ionViewDidLoad() {
    this.app.setTitle('Home');
  }

  addTask() {
   //this.nav.push(TasksDetailComponent);
  }
}



// WEBPACK FOOTER //
// ./src/pages/public/public.ts